// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wxn1","type":"styles_type__GwZmu","choices":"styles_choices__3WeR1"};